// extracted by mini-css-extract-plugin
export default {"container":"order-overview-item__container___R5pEu"};